import {
	AuthKeys,
	GetListRequest,
	ResponseWitOutData,
	GetPrincipalResponse,
	ListPrincipalsResponse,
	CreatePrincipalRequest,
} from '../types';
import { fetchData } from '../fetchService';
import { toSearchParams } from '../helpers/common';

const securityPrincipalService = {
	async create(
		baseUrl: string,
		principal: string,
		data: CreatePrincipalRequest,
		authKeys?: AuthKeys,
	): Promise<ResponseWitOutData> {
		return await fetchData(
			`${baseUrl}/principal?principal=${principal}`,
			'POST',
			data,
			authKeys,
		);
	},
	async get(
		baseUrl: string,
		principal: string,
		authKeys?: AuthKeys,
	): Promise<GetPrincipalResponse> {
		return await fetchData(
			`${baseUrl}/principal?principal=${principal}`,
			'GET',
			null,
			authKeys,
		);
	},
	async delete(
		baseUrl: string,
		principal: string,
		authKeys?: AuthKeys,
	): Promise<ResponseWitOutData> {
		return await fetchData(
			`${baseUrl}/principal?principal=${principal}`,
			'DELETE',
			null,
			authKeys,
		);
	},
	async getList(
		baseUrl: string,
		data?: GetListRequest,
		authKeys?: AuthKeys,
	): Promise<ListPrincipalsResponse> {
		const query = toSearchParams({ ...data });
		return await fetchData(
			`${baseUrl}/principal/match${query ? `?${query}` : ''}`,
			'GET',
			null,
			authKeys,
		);
	},
};

export default securityPrincipalService;
